export type ResponseOption =
    | "life_changing"
    | "positive"
    | "no_impact"
    | "negative"
    | "ask_later";

export type ImpactLevel = Exclude<ResponseOption, "ask_later">;

export type SubmissionSource =
    | "session_3_modal"
    | "session_6_modal"
    | "reminder_email"
    | "quit_flow";

export const REVIEW_OPTIONS: {
    key: ResponseOption;
    text: string;
}[] = [
    {
        key: "life_changing",
        text: "Life changing",
    },
    {
        key: "positive",
        text: "Positive impact",
    },
    {
        key: "no_impact",
        text: "No impact",
    },
    {
        key: "negative",
        text: "Negative impact",
    },
    {
        key: "ask_later",
        text: "Too early to say (ask me later)",
    },
];
